import { render } from "./detail-evaluasi-penyelenggaraan-pra_pelaksanaan.vue?vue&type=template&id=31ffcf1b"
import script from "./detail-evaluasi-penyelenggaraan-pra_pelaksanaan.vue?vue&type=script&lang=js"
export * from "./detail-evaluasi-penyelenggaraan-pra_pelaksanaan.vue?vue&type=script&lang=js"

import exportComponent from "/home/alfahuma/manual_build/digita-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__